import SiteNavbar from '@/cms/SiteNavbar';
import SiteFooter from '@/cms/SiteFooter';
import BlockRenderer from '@/cms/BlockRenderer';
import { useSiteContent } from '@/cms/useSiteContent';

export default function Home() {
  const { blocks, ready } = useSiteContent('home');

  return (
    <div className="min-h-screen bg-[#0B2421]">
      <SiteNavbar />
      {/* Hold a screen of space until the published blocks arrive on a
          first visit, rather than flashing the default hero images. */}
      {ready ? <BlockRenderer blocks={blocks} /> : <div className="min-h-screen" />}
      <SiteFooter />
    </div>
  );
}
